export default __webpack_public_path__ + "static/media/java.b4a0adbd.svg";